import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '../../../../components/Button/Button';
import { useInventorizeStepsStore } from '../../components/store';
import { useStore } from '../../useStore';
import { ReviewStepFooter as messages } from './messages';

export const ReviewStepFooter: React.VFC = () => {
  const { setPreviousStep } = useInventorizeStepsStore();
  const { commodity, newMeter, isSendingData } = useStore();
  const intl = useIntl();

  return (
    <>
      <Button
        block
        disabled={isSendingData}
        style={{ marginRight: 15 }}
        type="default"
        onClick={() => setPreviousStep({ commodity, newMeter })}
      >
        <FormattedMessage {...messages.back} />
      </Button>
      <Button key="submit" block form="reviewStepForm" htmlType="submit" loading={isSendingData} type="primary">
        {isSendingData ? intl.formatMessage(messages.sending) : intl.formatMessage(messages.confirm)}
      </Button>
    </>
  );
};
